// extracted by mini-css-extract-plugin
export default {"imageContainer":"H1-z","summaryPar":"I1-z","ratingCategories":"J1-z","reviewerInfo":"K1-z","reviewTypes":"L1-z","expanded":"M1-z"};